import { Language } from "./language";

//simple DTO to make new booking for Bruges/VND. can be deleted after updating booking creation process.
export class BasicStudent {

    constructor(
        public firstName: string,
        public lastName: string,
        public language: Language
    ){}
}
